"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'project.description.placeholder': 'Enter project description',
};
